import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ email, token, children }) => {
  const socketRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!email || !token) return;

    // 1️⃣ جلب الإشعارات القديمة من الـ API
    axios.get(`https://signal.osoulworld.com/api/notifications/user/${email}`, {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        setNotifications(res.data);
        const unread = res.data.filter((n) => !n.read && !n.read_at).length;
        setUnreadCount(unread);
      })
      .catch((err) => console.error("Error fetching notifications:", err));

    // 2️⃣ فتح اتصال WebSocket
const socket = new WebSocket(`wss://signal.osoulworld.com/ws/notifications/?email=${email}`);
    socketRef.current = socket;

    socket.onopen = () => console.log("WebSocket connected");

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("Notification received:", data);

      // ✅ تأكد إن الحقول النهائية موجودة
      const newNotification = {
        ...data,
        rendered_title: data.rendered_title || data.title || data.template?.title,
        rendered_body: data.rendered_body || data.body || data.template?.body,
      };

      // أضف الإشعار الجديد للـ state
      setNotifications((prev) => [newNotification, ...prev]);

      // تحديث العداد بناءً على حالة الإشعار
      if (!newNotification.read && !newNotification.read_at) {
        setUnreadCount((prev) => prev + 1);
      }
    };

    socket.onerror = (err) => console.error("WebSocket error:", err);

    socket.onclose = () => {
      console.log("WebSocket disconnected");
      socketRef.current = null;
    };

    return () => socket.close();
  }, [email, token]);

  // 3️⃣ دالة لتحديث حالة الإشعار وتقليل العداد
  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) =>
        n.id === id ? { ...n, read: true, read_at: new Date().toISOString() } : n
      )
    );
    setUnreadCount((prev) => Math.max(prev - 1, 0));
  };

  return (
    <WebSocketContext.Provider value={{ notifications, unreadCount, markAsRead }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
